var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('div',{staticClass:"text-center"},[_c('Qrcode',{attrs:{"width":200,"height":200,"text":_vm.text}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }